// import routesConfig from 'app/Atombo-configs/routesConfig';

const initialState = {};

const routes = function (state = initialState, action) {
    switch ( action.type )
    {
        default:
        {
            return state;
        }
    }
};

export default routes;
